module.exports = __webpack_public_path__ + "static/img/banner2.ac8e0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/banner2.png
// module id = 9Mfl
// module chunks = 1